export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11088.80a932f1.jpg";